export default __webpack_public_path__ + "static/media/exciting_pvp_battles.f62c498d.jpg";